/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';

import { QuestionVerificationStatus } from '../../interfaces/IWorkflow';
import colors from '../../theme/colors';
import { CheckCircleIcon, WarningIcon } from './icons';

interface QuestionVerificationStatusIconProps extends React.SVGProps<SVGSVGElement> {
  verificationStatus: QuestionVerificationStatus;
  disabled?: boolean;
}

export const QUESTION_VERIFICATION_STATUS_TOOLTIP = 'question-verification-status-tooltip';

const QuestionVerificationStatusIcon = ({
  verificationStatus,
  disabled = false,
  ...other
}: QuestionVerificationStatusIconProps) => {
  switch (verificationStatus) {
    case QuestionVerificationStatus.Verified: {
      const props = { color: disabled ? colors.neutral300 : colors.statusGreen, ...other };

      return (
        <CheckCircleIcon
          css={css`
            width: 18px;
            min-width: 18px;
            height: 18px;
          `}
          data-tooltip-id={QUESTION_VERIFICATION_STATUS_TOOLTIP}
          data-tooltip-content="Verified"
          {...props}
        />
      );
    }
    case QuestionVerificationStatus.NeedsVerification: {
      const props = { color: disabled ? colors.neutral300 : colors.orange400, ...other };

      return (
        <WarningIcon
          css={css`
            width: 18px;
            min-width: 18px;
            height: 18px;
          `}
          data-tooltip-id={QUESTION_VERIFICATION_STATUS_TOOLTIP}
          data-tooltip-content="Need verification"
          {...props}
        />
      );
    }
    default:
      return null;
  }
};

export default QuestionVerificationStatusIcon;
